"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isStorageFile(object) {
    return checkStorageFile(object).fulfilled;
}
exports.isStorageFile = isStorageFile;
function checkStorageFile(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasNumber("size"), __1.hasString("path"), __1.hasString("mimeType")).withOptions(options).explain();
}
exports.checkStorageFile = checkStorageFile;
//# sourceMappingURL=StorageFile.js.map